<template lang="pug">
  .b2b-page-comercial-relation
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
      ods-form(
        ref='comertialRelationDetailForm',
        :model='comertialRelationDetailForm',
        label-width='14rem',
        label-position='top',
        size='small',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              prop='buyerName',
               :label='$t("party_detail.channels.entity_table.buyer")')
              ods-input(
                :disabled='true',
                v-model='comertialRelationDetailForm.buyerName')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              prop='sellerName',
              :label='$t("party_detail.channels.entity_table.seller")')
              ods-input(
                :disabled='true',
                v-model='comertialRelationDetailForm.sellerName')

    ods-module.collapse
      ods-accordion.collapse(@change='')
        ods-accordion-item(name='1')
          template(slot='title')
            span {{ $t('party_detail.channels.channels_data') }}
            span.info(v-show='!channelLines.length') {{ $t('party_detail.channels.no_channels_data') }}
          //- Tabla lineas recepción
          ods-table(
            v-if='channelLines.length > 0 ',
            :data='channelLines',
            :default-sort="{prop: 'channelName', order: 'ascending'}",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='channelName',
              :label='$t("party_detail.channels.entity_table.channels")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='communicationsName',
              align='center'
              :label='$t("party_detail.channels.entity_table.communicationsMethod")',
              :show-overflow-tooltip='true',
              :formatter='formatterCommunicationMethod'
              sortable='')
            ods-table-column(
              width='80')
              template(slot-scope='scope')
                ods-button(
                  type='neutral',
                  @click='goUsers(scope.row)')
                  ods-icon(name='user', size='16')

    ods-dialog(
     :title='$t("party_detail.channels.dialog_users.title")',
    :visible.sync='isShowDialogUsers')
      ods-table(:data='users')
        ods-table-column(property='userName' :label='$t("party_detail.channels.dialog_users.userName")' )

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-comercial-relation',
  mixins: [Utils],
  data () {
    return {

      isShowDialogUsers: false,
      users: [],
      channelLines: [],
      statusDocumentRecadv: null,
      comertialRelationDetailForm: {
        id: null,
        projectId: null,
        partyByIdBuyer: null,
        buyerName: null,
        partyByIdSeller: null,
        sellerName: null,
        channel: null

      },
      currentRow: {}
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      // Permisos
      'canRejectRecadv'
    ])
  },

  methods: {
    ...mapActions([
      'getCommercialRelationDetail',
      'getChannelRelationComertial',
      'getUserChannelRelationComertial',
      'getServiceDetail',
      'getPartyService'
    ]),

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    // Formatear metodo de envio
    formatterCommunicationMethod (row, column) {
      if (row[column.property]) return this.$t('communication_method.' + row[column.property])
      else return ''
    },

    // Visualiza los usuarios de un canal
    async goUsers (channel) {
      try {
        const params = {
          buyerId: this.comertialRelationDetailForm.partyByIdBuyer,
          sellerId: this.comertialRelationDetailForm.partyByIdSeller,
          projectId: this.comertialRelationDetailForm.projectId,
          channelId: channel.channelId

        }
        this.users = await this.getUserChannelRelationComertial(params)
        this.isShowDialogUsers = true
      } catch (error) {
        console.log('goUsers() ->', error)
        this.getNotificationErrorMessage(error)
      }
    },
    // Canales
    async getChannelsOnDatabase () {
      // Get datos lineas  de la recepción
      try {
        const params = {
          buyerId: this.comertialRelationDetailForm.partyByIdBuyer,
          sellerId: this.comertialRelationDetailForm.partyByIdSeller,
          projectId: this.comertialRelationDetailForm.projectId
        }
        this.channelLines = await this.getChannelRelationComertial(params)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Detalle Relacion comercial
    async getComertialRelationDetailOnDatabase () {
      try {
        if (this.$route.params.partycommercialrelationId && this.$route.params.partycommercialrelationId !== undefined) {
          const request = {
            projectId: this.$route.params.projectId,
            partyId: this.$route.params.partyId,
            partycommercialrelationId: this.$route.params.partycommercialrelationId
          }
          this.comertialRelationDetailForm = await this.getCommercialRelationDetail(request)
          console.log(this.comertialRelationDetailForm)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    if (this.$route.params.partycommercialrelationId === 'centros') {
      const project = await this.getServiceDetail(this.$route.params.projectId)
      const party = await this.getPartyService({
        serviceId: this.$route.params.projectId,
        partyId: this.$route.params.partyId
      })

      sessionStorage.setItem('partyName', party.partyName)
      sessionStorage.setItem('projectName', project.name)

      router.push({
        name: 'table-centres',
        params: {
          partyId: this.$route.params.partyId,
          projectName: project.name,
          paryName: party.partyName
        }
      })
    } else {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        // Detalle Relación comercial
        await this.getComertialRelationDetailOnDatabase()
        // Canales
        await this.getChannelsOnDatabase()
      } catch (error) {
        console.log('created CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-comercial-relation {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .collapse {
    margin-top: 14px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row {
        .ods-button {
          padding: rem(0);
          margin-left: rem(0);
          margin-right: rem(0);
          i {
            margin-left: rem(0);
          }
        }
        .first-button {
          padding: rem(0);
          margin-left: rem(0);
          margin-right: rem(12);
          i {
            margin-left: rem(0);
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module {
      &__body {
        padding: 0px;
      }
    }
  }
}
</style>
